import React, { useEffect, useState } from "react";
import about from "./about.module.css";
import defaultIMG from "../../../Assets/defaultimg.png";
import { getALlExpertTeam } from "../../../Services/APIrequests";

const TeamConnect = () => {
  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = async () => {
    try {
      const response = await getALlExpertTeam();
      if (response?.data?.Status === 1) {
        setTeamMembers(response.data.assets || []);
      }
    } catch (error) {
      console.error("Error fetching expert team:", error);
    }
  };

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  return (
    <div className={about.team_container}>
      {/* <p className={about.teamHeader}>Our Member</p> */}
      <h2 className={about.title}>Expert <span className={about.title_span}>Team</span></h2>
      <p className={about.subtitle}>Meet the professionals behind our success</p>
      <div className={about.teamconnect_container}>
        {teamMembers.length > 0 ? (
          teamMembers.map((member, index) => (
            <div
              className={about.teamconnectBox}
              // data-aos="zoom-in"
              key={member.expertTeamId || index}
            >
              <div className={about.teamImage_container}>
                <img
                  src={
                    member.image && member.image !== "NA"
                      ? member.image
                      : defaultIMG
                  }
                  alt={member.name}
                  className={about.teamimg}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultIMG;
                  }}
                />
              </div>
              <div className={about.teamanme_container}>
                <p className={about.tname}>{member.designation}</p>
                <p className={about.rname}>{member.name}</p>
              </div>
            </div>
          ))
        ) : (
          <p style={{ color: "#666" }}>Loading team members...</p>
        )}
      </div>
    </div>
  );
};

export default TeamConnect;
